<template>
  <div class="apps-container">
    <div class="manage_app_main">
      <el-row style="display: flex;justify-content: space-between;">

        <el-col
          :span="
            havePerm('User.Market.Application.AppClassification.List') ? 18 : 24
          "
        >
          <div class="app_list_box" style="box-shadow: rgb(36 46 66 / 16%) 2px 4px 10px 0px;">
            <div class="flex-box">
              <public-table
                v-loading="Loading"
                :column="column"
                :emptyStatus="true"
                :tableData="tableData"
                :onAdd="() => (showCreateApp = true)"
                addPerm="User.Market.Application.Create"
                :enableSearch="true"
                :searchItems="searchItems"
                :PageInfo="listQuery"
                @handlePaginationChange="handleSearchList"
              >
                <template v-slot:name="{ row }">
                  <el-button
                    size="mini"
                    type="text"
                    @click="toAppDetailPage(row)"
                    >{{ row.name }}</el-button
                  >
                </template>
                <template v-slot:status="{ row }">
                  <span v-if="row.status == 'upShelves'" style="color: #13ce66">
                    已上架
                  </span>
                  <span
                    v-if="row.status == 'downShelves'"
                    style="color: #ff4949"
                    >未上架</span
                  >
                </template>
                <template v-slot:createTime="{ row }">
                  {{ row.createTime ? timetrans(row.createTime) : '-' }}
                </template>
                <template v-slot:publishType="{ row }">
                  {{ showPublishType(row.publishType) }}
                </template>
                <template v-slot:packageCount="{ row }">
                  <el-button
                    size="mini"
                    type="text"
                    @click="toAppPackagePage(row)"
                    >{{ row.packageCount }}</el-button
                  >
                </template>
                <template v-slot:versions="{ row }">
                  <el-button
                    v-if="row.versions && row.versions.length > 0"
                    size="mini"
                    type="text"
                    @click="toAppVersionPage(row)"
                    >{{ row.versions[0].appVersion }}</el-button
                  >
                  <template v-else>暂无版本</template>
                </template>
                <template v-slot:operation="{ row }">
                  <el-button
                    size="mini"
                    type="text"
                    v-permit="'User.Market.Application.Get'"
                    @click="toAppDetailPage(row)"
                    >管理</el-button
                  >
                  <el-button
                    size="mini"
                    type="text"
                    v-permit="'User.Market.Application.SetStatus'"
                    @click="handleShelves(row)"
                  >
                    {{ row.status == 'upShelves' ? '下架' : '上架' }}
                  </el-button>
                  <el-button
                    size="mini"
                    type="text"
                    v-permit="'User.Market.Application.Delete'"
                    @click="handleDelete(row)"
                    >删除</el-button
                  >
                </template>
              </public-table>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <CreatApp
      v-if="showCreateApp"
      :marketID="marketID"
      :dialogVisible="showCreateApp"
      :onSuccess="createAppSuccess"
      :onClose="() => (showCreateApp = false)"
    ></CreatApp>
    <CreateOrEditAppClass
      v-if="showClassEdit"
      :marketID="marketID"
      :appClass="appClass"
      :parentAppClass="parentAppClassification"
      :dialogVisible="showClassEdit"
      :onSuccess="createAppClassSuccess"
      :onClose="closeClassEdit"
    ></CreateOrEditAppClass>
  </div>
</template>
<script>
import { getSelfAppList } from '@/api/user';
import PublicTable from '@/components/PublicTable/index.vue';
import { havePerm } from '@/utils/auth';
import { timetrans } from '@/utils/validate';
import { errorHandle } from '../../../utils/error';
import CreatApp from './components/createApp';
import CreateOrEditAppClass from './components/createOrEditAppClass';
const defaultListQuery = {
  page: 1,
  pageSize: 10,
  total: 1,
  query: '',
  orgID: '',
  status: '',
  publishType: '',
  classIDs: ''
};

export default {
  name: 'AppManage',
  data() {
    const orgOptions = [];
    orgOptions.push({
      label: '全部',
      value: ''
    });
    this.$store.state.user.userOrgs.map((item) => {
      if (item) {
        orgOptions.push({
          label: item.name,
          value: item.orgID
        });
      }
    });
    const publishTypes = [
      {
        label: '全部',
        value: ''
      },
      {
        value: 'integral',
        label: '金额销售'
      },
      {
        value: 'public',
        label: '公开'
      },
      {
        value: 'private',
        label: '私有'
      },
      {
        value: 'show',
        label: '展览'
      }
    ];
    const appTypes = [
      {
        label: '全部',
        value: ''
      },
      {
        value: 'rainbond',
        label: 'rainbond'
      },
      {
        value: 'helm',
        label: 'Helm chart'
      }
      // {
      //   value: 'software',
      //   label: '文件'
      // }
    ];
    return {
      havePerm,
      showCreateApp: false,
      showClassEdit: false,
      parentAppClassification: {},
      timetrans,
      searchItems: [
        {
          label: '名称',
          name: 'query',
          value: '',
          type: 'input'
        },
        {
          label: '组织机构',
          name: 'orgID',
          value: '',
          type: 'select',
          options: orgOptions
        },
        {
          label: '上架状态',
          name: 'status',
          value: '',
          type: 'select',
          options: [
            {
              label: '全部',
              value: ''
            },
            {
              value: 'upShelves',
              label: '销售中'
            },
            {
              value: 'downShelves',
              label: '未上架'
            }
          ]
        },
        {
          label: '应用类型',
          name: 'appType',
          value: '',
          type: 'select',
          options: appTypes
        }
        // {
        //   label: '发布类型',
        //   name: 'publishType',
        //   value: '',
        //   type: 'select',
        //   options: publishTypes
        // }
      ],
      column: [
        {
          prop: 'name',
          label: '名称',
          scopeStatus: true
        },
        {
          prop: 'status',
          label: '上架状态',
          width: '70px',
          scopeStatus: true
        },
        {
          prop: 'classificationName',
          label: '分类'
        },
        {
          prop: 'templateType',
          label: '模板类型'
        },
        {
          prop: 'createTime',
          label: '更新时间',
          scopeStatus: true
        },
        {
          prop: 'versions',
          label: '版本',
          scopeStatus: true
        },
        {
          prop: 'packageCount',
          label: '套餐',
          scopeStatus: true,
          width: '50px'
        },
        {
          prop: 'operation',
          label: '操作',
          scopeStatus: true
        }
      ],
      publishTypes: publishTypes,
      tableData: [],
      listQuery: Object.assign({}, defaultListQuery),
      list: null,
      total: null,
      Loading: false,
      classTree: [],
      classLoading: true,
      appClass: {}
    };
  },
  computed: {
    marketID() {
      return this.$store.state.enterprise.enterpriseInfo.marketID;
    },
    // 当前用户信息
    currentUserInfo() {
      return this.$store.state.user.userInfo;
    }
  },
  components: {
    PublicTable,
    CreatApp,
    CreateOrEditAppClass
  },
  created() {
    this.handleCreated();
    if (havePerm('User.Market.Application.AppClassification.List')) {
      this.fetchStoreAppClassList();
    }
  },
  methods: {
    handleCreated() {
      // 企业管理员查看所有的应用列表
      if (
        havePerm('User.Market.Application.List') &&
        havePerm('User.Market.Application.SelfList')
      ) {
        this.fetchStoreAppList();
      } else {
        const params = {
          marketID: this.marketID,
          userID: this.currentUserInfo.userID,
          page: 1,
          pageSize: 10
        };
        // 否则的话,查看自己所管理的应用
        getSelfAppList(params).then((res) => {
          if (res && res.apps && res.apps.length > 0) {
            this.tableData = res.apps;
          } else {
            this.tableData = [];
          }
        });
      }
    },
    // 获取当前用户自己的应用
    handleLoadSelfApp() {},
    // 分类操作点击
    classHandleClick(cmd) {
      const data = this.curHandleClass;
      if (cmd === 'add') {
        this.addChildClass(data);
      } else if (cmd === 'modify') {
        this.editAppClass(data);
      } else {
        this.removeAppClass(data);
      }
    },
    // 分类操作
    classDropdownClick(c) {
      this.curHandleClass = c;
    },
    checkNode(node) {
      return node.level <= 1;
    },
    showPublishType(t) {
      let show = t;
      this.publishTypes.map((item) => {
        if (item.value == t) {
          show = item.label;
        }
      });
      return show;
    },
    handleSearchList(parameter) {
      if (parameter) {
        this.listQuery.page = 1;
        this.listQuery = Object.assign(this.listQuery, parameter);
      } else {
        this.listQuery.page = 1;
      }
      this.handleCreated();
    },
    handleDelete(row) {
      this.$confirm('是否要删除该应用?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store
          .dispatch('DeleteStoreApp', {
            marketID: this.marketID,
            appID: row.appKeyID
          })
          .then((res) => {
            if (res) {
              this.handleCreated();
              this.$message({
                type: 'success',
                message: '应用删除成功'
              });
            }
          })
          .catch((re) => {
            this.Loading = false;
            errorHandle(re);
          });
      });
    },
    handleShelves(row) {
      const message =
        row.status == 'upShelves' ? '是否要下架该应用?' : '是否要上架该应用?';
      const newStatus = row.status == 'upShelves' ? 'downShelves' : 'upShelves';
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store
          .dispatch('ChangeStoreAppStatus', {
            marketID: this.marketID,
            appID: row.appKeyID,
            status: newStatus
          })
          .then((res) => {
            if (res) {
              // 判断权限
              this.handleCreated();
              this.$message({
                type: 'success',
                message:
                  newStatus == 'upShelves' ? '应用上架成功' : '应用下架成功'
              });
            }
          })
          .catch((re) => {
            errorHandle(re);
          });
      });
    },
    toAppDetailPage(row) {
      this.$router.push({
        name: 'publishAppManageDetails',
        params: { appID: row.appKeyID, tabMode: 'detail' }
      });
    },
    toAppPackagesPage(row) {
      this.$router.push({
        name: 'StoreAppManagePackage',
        params: { appID: row.appKeyID }
      });
    },
    checkClassTree(data) {
      const nodes = this.$refs.classtree.getCheckedNodes();
      const classIDs = [];
      nodes.map((item) => {
        classIDs.push(item.appClassificationID);
      });
      if (classIDs.join(',') != this.listQuery.classIDs) {
        this.listQuery.classIDs = classIDs.join(',');
        this.handleCreated();
      }
    },
    fetchStoreAppList() {
      this.Loading = true;
      this.$store
        .dispatch(
          'GetStoreAppManageList',
          Object.assign({ marketID: this.marketID }, this.listQuery)
        )
        .then((res) => {
          if (res) {
            this.tableData = res.apps || [];
            this.listQuery.total = res.total;
          }
          this.Loading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.Loading = false;
        });
    },
    fetchStoreAppClassList() {
      this.classLoading = true;
      this.$store
        .dispatch('GetStoreAppClassificationList', { marketID: this.marketID })
        .then((res) => {
          if (res) {
            this.classTree = res.tree;
          }
          this.classLoading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.classLoading = false;
        });
    },
    addChildClass(node) {
      if (node) {
        this.parentAppClassification = node;
      }
      this.showClassEdit = true;
    },
    editAppClass(node) {
      this.appClass = node;
      this.showClassEdit = true;
    },
    createAppClassSuccess() {
      this.showClassEdit = false;
      this.fetchStoreAppClassList();
      this.handleCreated();
    },
    closeClassEdit() {
      this.parentAppClassification = {};
      this.appClass = {};
      this.showClassEdit = false;
    },
    createAppSuccess() {
      this.showCreateApp = false;
      this.handleCreated();
    },
    removeAppClass(node) {
      this.$confirm('删除后该分类下的应用将移除此分类，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store
            .dispatch('DeleteStoreAppClassification', {
              marketID: this.marketID,
              appClassificationID: node.appClassificationID
            })
            .then((res) => {
              this.fetchStoreAppClassList();
              this.handleCreated();
            })
            .catch((res) => {
              if (res.code === 10022) {
                this.$message({
                  message: '存在下级分类，不能删除',
                  type: 'warning'
                });
                return;
              }
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            });
        })
        .catch(() => {});
    },
    toAppVersionPage(row) {
      this.$router.push({
        name: 'StoreAppManageDetails',
        params: {
          appID: row.appKeyID,
          tabMode: 'versions'
        }
      });
    },
    toAppPackagePage(row) {
      this.$router.push({
        name: 'StoreAppManageDetails',
        params: {
          appID: row.appKeyID,
          tabMode: 'packages'
        }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.cens {
  text-align: center;
  padding: 30px;
  h6 {
    font-weight: 300;
    font-size: 20px;
    text-align: center;
  }
}

.titles {
  height: 40px;
  line-height: 40px;
  font-size: 20px;
  color: #2c3e50;
}

.app_class_tree,
.app_list_box {
  // border: 1px solid #e6e6e6;
  padding: 10px;
  overflow-x: auto;
  min-height: 500px;
  border-radius: 5px;
  background-color: #fff;

}
.app_class_tree {
  background-color: #fff;

}
.el-tree-node > .el-tree-node__children {
  overflow: inherit;
}
.flex-box {
  .common-table {
    width: 100%;
  }
}
.class_title {
  margin-bottom: 16px;
  display: block;
}
.classhandle {
  display: none;
  position: absolute;
  button {
    margin-left: 4px !important;
  }
}
.el-tree-node__content:hover .classhandle {
  display: inline;
}
.alert{
  margin: 20px 0px;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/generalUser/publishApp/index.vue